import { ValueOf } from 'shared/types/generic'

export const ButtonSizes = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  category: 'category',
  listinCategory: 'listingCategory',
  editOrder: 'editOrder'
} as const

export type ButtonSizes = ValueOf<typeof ButtonSizes>

export const ButtonVariants = {
  primary: 'primary',
  primaryOutline: 'primaryOutline',
  primaryText: 'primaryText',
  secondary: 'secondary',
  secondaryOutline: 'secondaryOutline',
  secondaryText: 'secondaryText',
  tertiary: 'tertiary',
  tertiaryOutline: 'tertiaryOutline',
  tertiaryText: 'tertiaryText',
  neutral: 'neutral',
  neutralOutline: 'neutralOutline',
  neutralText: 'neutralText',
  white: 'white',
  whiteOutline: 'whiteOutline',
  whiteText: 'whiteText',
  textInherit: 'textInherit',
  banners: 'banners'
} as const

export type ButtonVariants = ValueOf<typeof ButtonVariants>
